import React, { Fragment, useEffect, useState } from "react";
import { Button, Tab } from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import "./CustomEmissionDetailedView.scss";
import PersonSharpIcon from "@mui/icons-material/PersonSharp";
import {
  Card,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import {
  checkPermissions,
  dateParser,
  getYearFromDate,
  specialFloat,
} from "../../../helper";
import { TARGET_TYPES } from "../../../constants/enums";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getCustomEmissionService } from "../../../services/emissionService";
import FileAttachmentsDetails from "../../common/FileAttachmentsDetails";
import SkeletonLoader from "../../common/Skeletons/TableSkeleton/TableSkeletonLoader";

const CustomEmissionDetailedView = (props: any) => {
  const { t, i18n } = useTranslation();
  const permissions = useSelector((state: any) => state.auth.userPermissions);
  const {
    bunitData,
    onClose,
    controller,
    total_count,
    currentIndex,
    navigateNext,
    typeInfo,
  } = props;
  const { business_unit: unitId, name: bunit_name } = bunitData;
  const [currencies, setCurrencies] = useState<any>("");
  const navigate = useNavigate();
  const [cellColumns, setCellColumns] = useState([
    "Activity name",
    "Year",
    "Emission factor",
    "Factor UOM",
    "Data ID",
  ]);
  const [list, setlist] = useState({
    activityName: "gass/",
  });
  const [customEmissionDetails, setCustomEmissionDetails] = useState({
    categorycode: "",
    categoryname: "",
    sourcename: "",
    sourcelinkname: "",
    methodname: "",
    activities: [],
    methodurlname: "",
  });
  const [isLoading, setIsLoading] = useState(true);
  const [emissionAttachmentData, setEmissionAttachmentData] = useState({
    id: "",
    attachments: [],
  } as any);

  const { page, limit } = controller;
  let index = limit * page + currentIndex;

  const openEdit = () => {
    navigate("/datasource/customemission/" + typeInfo.methodName, {
      state: { customEmissionDetails: customEmissionDetails },
    });
  };

  const onNavigateNext = (increment: number) => {
    if (increment > 0 && currentIndex === limit - 1) {
      navigateNext(increment, 1);
    } else if (increment < 0 && currentIndex === 0) {
      navigateNext(increment, -1);
    } else {
      navigateNext(increment, 0);
    }
  };
  useEffect(() => {
    const reqObj: any = {
      method: typeInfo.methodName,
      sub_type: typeInfo.typeName,
      type: bunitData.data[0].id,
      category: bunitData.cateogry,
    };
    getCustomEmissionService(reqObj).then((res) => {
      if (res.data.attachments) {
        setEmissionAttachmentData({
          attachments: [...res.data.attachments.files],
          id: res.data.method,
        });
      } else {
        setEmissionAttachmentData({});
      }
      setCustomEmissionDetails(res.data);
      setIsLoading(false);
    });
  }, [typeInfo]);

  return (
    <div className="flex w-70 flex-col px-4 grow pw-detailed-view-main">
      <div className="pw-bunit-detailed-header w-full flex justify-end gap-3 pr-2">
        {checkPermissions(["CREATE_EMISSION_FACTOR"], permissions) ? (
          <Button onClick={openEdit} className="pw-editbox-emission">
            <CreateIcon className="pw-bunit-edit-icon text-neutral-600" />
            <div className="pw-edit">Edit</div>
          </Button>
        ) : (
          ""
        )}
        {/* <ArrowBackIosNewIcon onClick={()=>navigateNext(-1)} className="pw-navigate-next"/>
            <NavigateNextIcon onClick={()=>navigateNext(1)} className="pw-navigate-next"/>
            <CloseIcon onClick={onClose} className="pw-navigate-next"/> */}
        {index > 0 && (
          <div
            onClick={() => onNavigateNext(-1)}
            className="pw-navigate-next pw-padding-5"
          >
            <img src="assets/icons/prev.svg" alt=" " />
          </div>
        )}
        {index < total_count - 1 && (
          <div
            onClick={() => onNavigateNext(1)}
            className="pw-navigate-next pw-padding-5 pw-bunit-next"
          >
            <img src="assets/icons/next.svg" alt=" " />
          </div>
        )}

        <div
          onClick={() => onClose()}
          className="pw-navigate-next items-center"
        >
          <CloseIcon className=" items-center text-neutral-600" />
        </div>
      </div>
      <div className="flex flex-col pw-detail-main-content gap-3">
        <div className="flex flex-row gap-5">
          <div className="flex flex-col justify-center grow">
            <div className="pw-bunit-detail-name text-l text-neutral-900">
              {customEmissionDetails.categorycode}{" "}
              {customEmissionDetails.categoryname}
            </div>
          </div>
        </div>
        <div className="flex flex-row justify-between">
          <div className="flex flex-row">
            <p className="text-neutral-600 text-sm">{t("Source Name")}: </p>
            &nbsp;
            <p className="text-sm text-neutral-900 ">
              {customEmissionDetails.sourcename}
            </p>
          </div>
          <div className="flex flex-row">
            <p className="text-neutral-600 text-sm">{t("Source URL")}: </p>
            &nbsp;
            <p className="text-sm text-neutral-900 ">
              {customEmissionDetails.sourcelinkname}
            </p>
            &nbsp;
          </div>
        </div>
        <FileAttachmentsDetails
          emissionAttachmentData={emissionAttachmentData}
          setEmissionAttachmentData={setEmissionAttachmentData}
          fromEmissionDetail={true}
        />
      </div>
      {isLoading ? (
        <SkeletonLoader type="text" cells={cellColumns} />
      ) : (
        <Fragment>
          <div className="flex flex-col gap-3">
            <div className="flex mt-5 pl-5 text-primary">
              {customEmissionDetails.methodname}
            </div>
            <div className="flex flex-col bg-white p-2 justify-between gap-2 text-neutral-600">
              <p className="text-sm pl-2">
                {t("Activity URL")}: {customEmissionDetails.methodurlname}
              </p>
              <Table className="pw-custom-emission-detailed">
                <TableHead className="bg-neutral-50 pw-custom-table pw-activity-table-head">
                  <TableRow className="text-neutral-600">
                    {cellColumns.map((eachCell, index) => (
                      <TableCell
                        key={index}
                        sx={{ border: "1px solid  #eaeef4" }}
                      >
                        {t(eachCell)}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {customEmissionDetails?.activities?.length &&
                    customEmissionDetails?.activities.map(
                      (eachActivity: any) => {
                        return (
                          <TableRow>
                            <TableCell
                              className="pw-table-border"
                              style={{ borderLeft: "1px solid #eaeef4" }}
                            >
                              {eachActivity.activityName}
                            </TableCell>
                            <TableCell className="pw-table-border">
                              {eachActivity.isDefault === true
                                ? "default"
                                : getYearFromDate(eachActivity.fromDate)}
                            </TableCell>
                            <TableCell>
                              {eachActivity.uoms.map((eachUom: any) => {
                                return (
                                  <>
                                    {eachUom.symbol.includes("CO2e") ? (
                                      <></>
                                    ) : (
                                      <TableRow>
                                        <TableCell>
                                          {`Individual gases for ${
                                            eachUom.symbol.split("/")[1]
                                          }`}{" "}
                                        </TableCell>
                                      </TableRow>
                                    )}
                                    {Object.keys(eachUom.values).map(
                                      (eachValue: any) => {
                                        return (
                                          <TableRow>
                                            <TableCell
                                              align="right"
                                              className="pw-table-border"
                                            >
                                              {eachUom.values[eachValue]}
                                            </TableCell>
                                          </TableRow>
                                        );
                                      }
                                    )}
                                  </>
                                );
                              })}
                            </TableCell>
                            <TableCell>
                              {eachActivity.uoms.map((eachUom: any) => {
                                const gasNames = Object.keys(eachUom.values);
                                const unit = eachUom.symbol.split(" ")[0];
                                const uomName = eachUom.symbol.split("/")[1];
                                return (
                                  <>
                                    {eachUom.symbol.includes("CO2e") ? (
                                      <></>
                                    ) : (
                                      <TableRow>
                                        <TableCell></TableCell>
                                      </TableRow>
                                    )}
                                    {gasNames.map((eachGas: any) => {
                                      return (
                                        <TableRow>
                                          <TableCell className="pw-table-border">
                                            {`${unit} ${
                                              eachUom.symbol.includes("CO2e")
                                                ? "CO2e"
                                                : eachGas
                                            }/${uomName}`}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </>
                                );
                              })}
                            </TableCell>
                            <TableCell>
                              {eachActivity.uoms.map((eachUom: any) => {
                                const gasNames = Object.keys(eachUom.values);
                                return (
                                  <>
                                    {eachUom.symbol.includes("CO2e") ? (
                                      <></>
                                    ) : (
                                      <TableRow>
                                        <TableCell
                                          sx={{ borderRight: "1px solid " }}
                                        ></TableCell>
                                      </TableRow>
                                    )}
                                    {gasNames.map((eachGas: any) => {
                                      return (
                                        <TableRow>
                                          <TableCell className="pw-table-border">
                                            {eachUom.local_code}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </>
                                );
                              })}
                            </TableCell>
                          </TableRow>
                        );
                      }
                    )}
                </TableBody>
              </Table>
            </div>
          </div>
        </Fragment>
      )}
    </div>
  );
};

export default CustomEmissionDetailedView;
